import React from "react";
import maritex from "./../media/maritex-logo.svg";
import niviss from "./../media/logo_niviss_300dpi.svg";

// database
import data from "../main.json";

function Footer() {
  return (
    <footer className="footer-custom">
      <div className="footer-box">
        <a
          href="https://www.maritex.com.pl"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-item"
        >
          <img src={maritex} alt="Maritex Logo" className="footer-logo" />
        </a>
        <div className="footer-item">+48 58 622 89 00</div>
        <div className="footer-item">ul. Rdestowa 53d, 81-577 Gdynia</div>
        <div className="footer-item">
          <a
            href={`mailto:maritex@maritex.com.pl`}
            className="footer-item-email"
          >
            maritex@maritex.com.pl
          </a>
        </div>
      </div>
      <div className="footer-box">
        <a
          href="https://www.niviss.com"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-item"
        >
          <img src={niviss} alt="Niviss Logo" className="footer-logo" />
        </a>
        <div className="footer-item">+48 58 781 33 99</div>
        <div className="footer-item">ul. Rdestowa 53d, 81-577 Gdynia</div>
        <div className="footer-item">
          <a href={`mailto:info@niviss.com`} className="footer-item-email">
            info@niviss.com
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
